import React from 'react';
import {Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, RadialBarChart, RadialBar,AreaChart,PieChart,Pie,  Sector,Legend, Cell,Tooltip,CartesianGrid,XAxis,YAxis, Area,ResponsiveContainer} from 'recharts';
import parseISO from 'date-fns/parseISO';
import subDays from 'date-fns/subDays';
import format from 'date-fns/format';
import '../gestrela.css';
function GestRelatorios(){
    const datas=[];
    const COLORS = ['#053f40', '#ca2210', '#ffa500'];
    const dataa=[];
    for(let num=30;num>=0;num--){
        dataa.push({
            date:subDays(new Date(),num).toISOString().substr(0,10),
            value:1+Math.random(),
            mpesa:1-Math.random(),
            emola:0.5*Math.random(),
        })
    }
    
    const datass = [
        {
          subject: 'M_PESA',
          A: 120,
          B: 110,
          C:30,
          fullMark: 150,
        },
        {
          subject: 'E_MOLA',
          A: 98,
          B: 130,
          C:56,
         
          fullMark: 150,
        },
        {
          subject: 'VISA',
          A: 86,
          B: 130,
          C:10,
         
          fullMark: 150,
        },
        {
          subject: 'RecargaAKI',
          A: 99,
          B: 100,
          C:127,
         
          fullMark: 150,
        },
        {
          subject:'PayPal',
          A: 85,
          B: 90,
          C:123,
         
          fullMark: 150,
        },
        {
          subject: 'PONTO24',
          A: 65,
          B: 85,
          C:120,
         
          fullMark: 150,
        },
      ];
      
    const data = [
       
        {
          name: 'TSC',
          uv: 56.69,
          pv: 4567,
          fill: '#00FF00',
        },
        {
          name: 'IVA',
          uv: 50.69,
          pv: 1398,
          fill: '#8dd1e1',
        },
        {
            name: 'Lucro',
            uv: 80   ,
            pv: 4800,
            fill: '#053f40',
          },
        {
          name: 'TOTAL',
          uv: 100   ,
          pv: 4800,
          fill: '#ffc658',
        },
      ];
    const style = {
        top: '50%',
        right: 0,
        transform: 'translate(0, -50%)',
        lineHeight: '24px',
      };
    for(let num=2;num>=0;num--){
        datas.push({
            date:subDays(new Date(),num).toISOString().substr(0,10),
            value:1+Math.random(),
            mpesa:1-Math.random(),
            emola:0.5*Math.random(),
        })
    }
    return <div className='Relatorio'>
        <div id="total">
            <div id="m3">
            <ResponsiveContainer   className="casa">
            <PieChart >
            <Pie
            data={datas}
            cx={120}
            cy={90}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
                     >
            {datas.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
            
            </Pie>
   
                <Tooltip/>
            </PieChart>
          
        </ResponsiveContainer>
        <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart cx="50%" cy="50%" innerRadius="10%" outerRadius="80%" barSize={10} data={data}>
          <RadialBar
            minAngle={15}
            label={{ position: 'insideStart', fill: '#fff' }}
            background
            clockWise
            dataKey="uv"
          />
          <Legend iconSize={10} layout="vertical" verticalAlign="middle" wrapperStyle={style} />
        </RadialBarChart>
      </ResponsiveContainer>
      <ResponsiveContainer >
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={datass}>
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis angle={30} domain={[0, 150]} />
          <Radar name="APPMOBILE" dataKey="A" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
          <Radar name="USSD" dataKey="B" stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.6} />
          <Radar name="PAGINA WEB" dataKey="C" stroke="#ffa500" fill="#ca2210" fillOpacity={0.15} />
         
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
     
      
            </div>
            <div>
            <ResponsiveContainer width="100%" height={300}  className="casa">
      <AreaChart data={dataa} >
        <defs>
            <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#053f40' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#053f40' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colors" x1="0" y1="0" x2="0" y2="1">

                <stop offset="0%" stopColor='#ca2210' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ca2210' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#ffa500' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ffa500' stopOpacity={0.05}></stop>
            </linearGradient>
        </defs>
        <Area dataKey="value" stroke="#053f40" fill="url(#color)"/>
        <Area dataKey="mpesa" stroke="#ca2210" fill="url(#colors)"/>
        <Area dataKey="emola" stroke="#ffa500" fill="url(#colorsa)"/>
        
        <XAxis dataKey="date"
        axisLine={false}
        tickLine={false}
        tickFormatter={str=>{
            const date=parseISO(str);
            if(date.getDate() %7==0){
                return  format(date,"MMM, d")
            }
            return ""
        }}/>
        <YAxis dataKey="value"
        axisLine={false}
        tickLine={false}
        tickCount={8}
        tickFormatter={number=>`$${number.toFixed(2)}`}/>
        <Tooltip/>
        <CartesianGrid opacity={0.1} vertical={false}/>
      </AreaChart>
  </ResponsiveContainer>

            </div>
        </div>
    </div>;
}

export default GestRelatorios